import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./vuex";

import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import { MessageBox } from "element-ui";

import axios from "axios";
import VueAxios from "vue-axios";
import VueAwesomeSwiper from "vue-awesome-swiper";

import VueTypedJs from "vue-typed-js";

import { toMoney } from '@/utils/utils'

// 导入反馈模块
import { showFeedback, hideFeedback, destroyFeedback } from '@/utils/feedbackManager'

Vue.use(VueTypedJs);
Vue.filter('toMoney', toMoney)

// main.js

//引入阿里云图标库
import "@/assets/icon/iconfont.css";

import "codemirror/lib/codemirror.css";

import "codemirror/addon/hint/show-hint.css";
import elTableInfiniteScroll from "el-table-infinite-scroll";

Vue.config.productionTip = false;
Vue.use(elTableInfiniteScroll);
// import style
import "swiper/swiper-bundle.css";
Vue.use(VueAwesomeSwiper);
//配置分页器
import { Swiper as SwiperClass, Pagination } from "swiper";
SwiperClass.use([Pagination]);
// permission  权限控制
import "./permission";
// 自定义指令
import "./directives/";
import "./styles/index.scss";

//引入引导页面
import Driver from "driver.js";
import "driver.js/dist/driver.min.css";

import mavonEditor from "mavon-editor";
import "mavon-editor/dist/css/index.css";
// use
Vue.use(mavonEditor);

Vue.prototype.$driver = new Driver({
  doneBtnText: "完成", // Text on the final button
  closeBtnText: "关闭", // Text on the close button for this step
  stageBackground: "#fff", // Background color for the staged behind highlighted element
  nextBtnText: "下一步", // Next button text for this step
  prevBtnText: "上一步", // Previous button text for this step
});

// 引入echarts
import * as echarts from "echarts";
Vue.prototype.$echarts = echarts;

import { codemirror } from "vue-codemirror";
import "codemirror/lib/codemirror.css";
Vue.use(codemirror);

Vue.use(ElementUI);
Vue.use(VueAwesomeSwiper);
Vue.config.productionTip = false;
Vue.use(VueAxios, axios);

// 注册反馈模块为全局方法
Vue.prototype.$showFeedback = showFeedback
Vue.prototype.$hideFeedback = hideFeedback
Vue.prototype.$destroyFeedback = destroyFeedback

//定义全局变量
Vue.prototype.measurementId = function () {
  var measurementId = "G-5MTRD26299";
  return measurementId;
};

Vue.prototype.apiSecret = function () {
  var apiSecret = "8T3DHkdfTGytDgKzIMdyEQ";
  return apiSecret;
};

import { log } from '@/utils/prettyConsole'
window.log = log;

// 正式环境清除所有console.log

if (process.env.NODE_ENV === "production") {
  if (window) {
    window.console.log = function () { };
  }
}

// 监听localStorage变化，同步更新Vuex状态
window.addEventListener('storage', (e) => {
  if (e.key === 'vuex') {
    try {
      const newValue = JSON.parse(e.newValue);
      const oldValue = JSON.parse(e.oldValue || '{}');

      // 判断是否在超管端，通过路由地址是否包含'/background/'
      const isInAdminPanel = window.location.pathname.includes('/background/');

      if (newValue && newValue.user) {
        // 检查token是否发生改变
        const newToken = newValue.user.token || '';
        const oldToken = (oldValue.user && oldValue.user.token) || '';

        // 如果token改变了且两者都不为空，显示提示并刷新页面
        if (newToken !== oldToken && newToken && oldToken && !isInAdminPanel) {
          MessageBox.confirm('检测到您的登录账号发生改变！', '账号变更', {
            confirmButtonText: '确定',
            showCancelButton: false,
            showClose: false,
            closeOnClickModal: false,
            closeOnPressEscape: false,
            type: 'warning'
          }).then(() => {
            router.replace('/login');
          }).catch(() => {
            // 用户无法取消，但仍需同步token状态
            syncVuexState(newValue);
          });
          return;
        }

        // 检查token是否丢失
        if (!newValue.user.token || newValue.user.token === '') {
          // 原来有token现在没有了，说明退出登录了
          if (oldValue.user && oldValue.user.token && !isInAdminPanel) {
            MessageBox.confirm('检测到您的账号已登出，请重新登录！', '账号登出', {
              confirmButtonText: '去登录',
              showCancelButton: false,
              showClose: false,
              closeOnClickModal: false,
              closeOnPressEscape: false,
              type: 'warning'
            }).then(() => {
              store.dispatch("LogOut").then(() => {
                router.push('/login');
              });
            }).catch(() => {
              // 用户无法取消，但仍需同步状态
              syncVuexState(newValue);
            });
            return;
          }
        }

        // 默认同步状态
        syncVuexState(newValue);
      } else if (oldValue.user && oldValue.user.token && !isInAdminPanel) {
        // 用户数据被完全清除，且原来存在token，显示登出提示
        MessageBox.confirm('检测到您的账号已登出，请重新登录！', '账号登出', {
          confirmButtonText: '去登录',
          showCancelButton: false,
          showClose: false,
          closeOnClickModal: false,
          closeOnPressEscape: false,
          type: 'warning'
        }).then(() => {
          store.dispatch("LogOut").then(() => {
            router.push('/login');
          });
        });
      }
    } catch (error) {
      console.error('同步Vuex状态失败', error);
      window.isUpdatingFromStorage = false;
    }
  }
});

// 封装状态同步函数，避免代码重复
function syncVuexState(newValue) {
  // 设置标记，表示当前更新来自storage事件
  window.isUpdatingFromStorage = true;

  // 从localStorage同步token到Vuex store
  store.commit('SET_TOKEN', newValue.user.token || '');
  store.commit('SET_USERNAME', newValue.user.username || '');
  store.commit('SET_IDENTITY', newValue.user.identity || '');
  store.commit('SET_USERINFO', newValue.user.userInfo || {});
  store.commit('SET_SCHOOLINFO', newValue.user.schoolInfo || {});
  store.commit('SET_PRINCIPAL', newValue.user.is_principal || '');
  store.commit('SET_ROLE', newValue.user.roleList || []);
  store.commit('SET_PERMISION', newValue.user.permisionList || []);
  if (newValue.user.adminToken) {
    store.commit('SET_ADMINTOKEN', newValue.user.adminToken || '');
  }

  // 重置标记
  setTimeout(() => {
    window.isUpdatingFromStorage = false;
  }, 0);
}

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");


console.log('当前环境', process.env.VUE_APP_BASE_URL)
console.log('当前环境', process.env)